import * as constants from './config/constants.js';
import moment from 'moment';
import ElementClassHandler from './utils/element-class-handler';
import Selectors from './utils/selectors.js';

const elementClassHandler = new ElementClassHandler,
    selectors = new Selectors({
        dataAttrId: 'data-delivery-selection-id'
    });

export default class {
    constructor(options = {}) {
        this.elementIdentifier = options.elementIdentifier || '';
        this.validDeliveryCombinationsInput = selectors.dataAttr(this.elementIdentifier + '_valid-delivery-combinations') + ' input';
        this.dateSelectionInput = selectors.dataAttr(this.elementIdentifier + '_date-selection') + ' input';
        this.carrierSelection = selectors.dataAttr(this.elementIdentifier + '_carrier-selection');
    }

    setup() {
        this.getValidDeliveryCombinations();
        this.selectFirstAvailableDay();
        this.setupDateSelectionChangeListener();
        this.setupCarrierSelectionChangeListener();
        this.setCorrectcarrierRadioOptions();
        this.selectFirstAvailableCarrier();
    }

    getValidDeliveryCombinations() {
        const deliveryCombinations = document.querySelector(this.validDeliveryCombinationsInput);
        if (typeof deliveryCombinations.value === 'string') {
            this.validDeliveryCombinationValues = JSON.parse(deliveryCombinations.value);
        }
    }

    setupDateSelectionChangeListener() {
        const dateSelection = selectors.querySelectorArray(this.dateSelectionInput);
        if (dateSelection.length) {
            dateSelection.forEach(el => el.addEventListener('change', (e) => {
                e.preventDefault();
                this.setCorrectCarrierOptions(el.value);
                this.setCorrectcarrierRadioOptions();
                this.selectFirstAvailableCarrier();
            }));
        }
    }

    setupCarrierSelectionChangeListener() {
        const carrierOptions = selectors.querySelectorArray(this.carrierSelection + ' input');
        if (carrierOptions.length) {
            carrierOptions.forEach(el => el.addEventListener('change', (e) => {
                e.preventDefault();
                let chosenDate = document.querySelector(this.dateSelectionInput + ':checked').value,
                    carrierRadioOptions = selectors.querySelectorArray(this.carrierSelection + ' ' + constants.RADIO_BUTTON_SELECTOR),
                    deliveryCarriersForDay = this.validDeliveryCombinationValues[moment(chosenDate).format('E')];
                carrierRadioOptions.forEach((el) => {
                    let input = el.querySelector('input');
                    if (input.getAttribute('checked')) {
                        input.removeAttribute('checked');
                    }
                    if (!deliveryCarriersForDay.includes(parseInt(input.value))) {
                        elementClassHandler.hide(el);
                    }
                });
            }));
            this.selectFirstAvailableCarrier();
        }
    }

    setCorrectCarrierOptions(chosenDate) {
        const carrierOptions = selectors.querySelectorArray(this.carrierSelection + ' ' + constants.RADIO_BUTTON_SELECTOR),
            deliveryCarriersForDay = this.validDeliveryCombinationValues[moment(chosenDate).format('E')];
        carrierOptions.forEach((el) => {
            let input = el.querySelector('input');
            if (deliveryCarriersForDay.includes(parseInt(input.value))) {
                elementClassHandler.show(el);
                return;
            }
            elementClassHandler.hide(el);
        });
        this.selectFirstAvailableCarrier();
    }

    setCorrectcarrierRadioOptions() {
        const chosenDate = document.querySelector(this.dateSelectionInput + ':checked').value,
            carrierOptions = selectors.querySelectorArray(this.carrierSelection + constants.RADIO_BUTTON_SELECTOR),
            deliveryCarriersForDay = this.validDeliveryCombinationValues[moment(chosenDate).format('E')];
        carrierOptions.forEach((el) => {
            let input = el.querySelector('input');
            if (input.getAttribute('checked')) {
                input.removeAttribute('checked');
            }
            if (!deliveryCarriersForDay.includes(parseInt(el.value))) {
                elementClassHandler.hide(el);
                return;
            }
            elementClassHandler.show(el);
        });
        this.selectFirstAvailableCarrier();
    }

    selectFirstAvailableDay() {
        let checkedDate = document.querySelector(this.dateSelectionInput + ':checked');
        if (!checkedDate) {
            checkedDate = document.querySelector(this.dateSelectionInput);
            checkedDate.checked = true;
        }
        if (checkedDate.length !== null) {
            this.setCorrectCarrierOptions(checkedDate.value);
        }
    }

    selectFirstAvailableCarrier() {
        let firstAvailablecarrier = document.querySelector(this.carrierSelection + ' ' + constants.RADIO_BUTTON_SELECTOR + ':not(.' + constants.HIDE_ELEMENT_CLASS + ') input');
        if (firstAvailablecarrier) {
            firstAvailablecarrier.checked = true;
        }
    }
}
